<div
  id="DrawComponent"
  class="card esri-widget animation-on-tool-open"
  #drawComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
>
  <!--- the panel header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-8" translate>
        WIDGET.DRAW.PANEL_HEADING
      </div>
      <div class="col-md-4">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>

  <!-- the panel body -->
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <sketch></sketch>
      </div>
    </div>
  </div>
</div>
